import {
  forbiddenViewTranslation,
  ForbiddenViewTranslation,
} from '@/assets/locales/views/util/forbidden/forbiddenView.translation.pl.ts';
import {
  maintenanceViewTranslation,
  MaintenanceViewTranslation,
} from '@/assets/locales/views/util/maintenance/maintenanceView.translation.pl.ts';

export type UtilViewsTranslation = {
  forbidden: ForbiddenViewTranslation;
  maintenance: MaintenanceViewTranslation;
};

export const utilViewsTranslation = {
  forbidden: forbiddenViewTranslation,
  maintenance: maintenanceViewTranslation,
};
